<template>
  <canvas :class="currentClass" ref="confetti-canvas"></canvas>
</template>

<script>
import confetti from "canvas-confetti";
import JSConfetti from "js-confetti";

export default {
  props: ["number"],
  data() {
    return {
      isPlaying: false,
      confettiInstance: null,
      emojiShapes: {},
      jsConfetti: null,
    };
  },
  created() {
    setTimeout(this.setConfettis, 1000);
  },
  computed: {
    currentClass() {
      return this.isPlaying ? "confettis-playing" : "confettis";
    },
    useOld() {
      return navigator.userAgent.toLowerCase().includes("firefox");
    },
  },
  methods: {
    setConfettis() {
      if (this.useOld) {
        this.jsConfetti = new JSConfetti({
          canvas: this.$refs["confetti-canvas"],
        });
      } else {
        this.confettiInstance = confetti.create(this.$refs["confetti-canvas"], {
          resize: true,
          useWorker: true,
        });
      }
    },
    launchConfettis(emojis = []) {
      if (this.useOld) this.launchOld(emojis);
      else this.launchNew(emojis);
    },
    launchNew(emojis) {
      if (!this.confettiInstance || emojis.length === 0) return;

      this.isPlaying = true;

      const minWidth = 390;
      const maxWidth = 1920;
      const screenWidth = window.innerWidth;

      // Clamp la valeur entre 0 (pour 390px) et 1 (pour 1920px)
      const t = Math.min(
        Math.max((screenWidth - minWidth) / (maxWidth - minWidth), 0),
        1
      );

      // Interpolation linéaire
      const scalar = 5 + (7 - 5) * t;
      const velocityFactor = 4 + (12 - 4) * t;
      const particleCount = Math.round(20 + (30 - 20) * t);
      const yOrigin = 0.9 + (0.6 - 0.9) * t;

      const dx = screenWidth / 2;
      const dy = window.innerHeight * 0.5;
      const idealVelocity = dx / velocityFactor;

      const angleLeft = Math.atan2(dy, dx) * (180 / Math.PI) + 10;
      const angleRight = 180 - angleLeft;

      // Génère chaque shape emoji une seule fois
      const shapes = emojis.map((emoji) => {
        if (!this.emojiShapes[emoji]) {
          this.emojiShapes[emoji] = confetti.shapeFromText({
            text: emoji,
            scalar,
          });
        }
        return this.emojiShapes[emoji];
      });

      const config = {
        particleCount,
        spread: 50,
        shapes,
        scalar,
        zIndex: 1000,
        gravity: 3,
        flat: true,
        rotate: true,
        rotationSpeed: 3,
        fadeStart: 0.7,
        startVelocity: idealVelocity,
      };

      this.$nextTick(() => {
        this.confettiInstance({
          angle: angleLeft,
          origin: { x: -0.05, y: yOrigin },
          ...config,
        });

        this.confettiInstance({
          angle: angleRight,
          origin: { x: 1.05, y: yOrigin },
          ...config,
        });

        setTimeout(() => {
          this.isPlaying = false;
        }, 3000);
      });
    },
    launchOld(emojis) {
      if (this.jsConfetti !== null) {
        this.isPlaying = true;
        this.$nextTick(() => {
          this.jsConfetti.addConfetti({
            emojis,
            emojiSize: 70,
            confettiNumber: this.number || undefined,
          });
          setTimeout(() => {
            this.isPlaying = false;
          }, 3000);
        });
      }
    },
  },
};
</script>

<style scoped>
.confettis {
  position: absolute;
  width: 0px;
  height: 0px;
}

/* fixed : le body est en position relative (motifs de fond), un canvas
   absolute ferait toute la hauteur de la page au lieu de l'écran */
.confettis-playing {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  pointer-events: none;
}
</style>
